module.exports = __webpack_public_path__ + "img/government-programme-value1.775ce33c.png";